.logInBackground {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    flex-direction: column;
}

.logInTitle {
    text-align: center;
}

.animation {
    width: 800px;
}